export const REFRESH_DELAY = 5000;

export const dropRelations = {
  null: null,
  before: "before",
  after: "after",
  directly: "directly",
};

export const sessionStorageDisabledConfirmationsKey = "disabledConfirmations";

export const MAX_REFRESH_ATTEMPTS = 5;

// Available countries for SelectLanguageView
export const countries = [
  { label: "Austria", value: "at", translationKey: "EVENT_COUNTRY_AUSTRIA" },
  { label: "Belgium", value: "be", translationKey: "EVENT_COUNTRY_BELGIUM" },
  {
    label: "Switzerland",
    value: "ch",
    translationKey: "EVENT_COUNTRY_SWITZERLAND",
  },
  { label: "Germany", value: "de", translationKey: "EVENT_COUNTRY_GERMANY" },
  { label: "Denmark", value: "dk", translationKey: "EVENT_COUNTRY_DENMARK" },
  { label: "Spain", value: "es", translationKey: "EVENT_COUNTRY_SPAIN" },
  { label: "France", value: "fr", translationKey: "EVENT_COUNTRY_FRANCE" },
  {
    label: "Netherlands",
    value: "nl",
    translationKey: "EVENT_COUNTRY_NETHERLANDS",
  },
  { label: "Norway", value: "no", translationKey: "EVENT_COUNTRY_NORWAY" },
  { label: "Sweden", value: "se", translationKey: "EVENT_COUNTRY_SWEDEN" },
  {
    label: "United Kingdom",
    value: "uk",
    translationKey: "EVENT_COUNTRY_UNITED_KINGDOM",
  },
  { label: "Romania", value: "ro", translationKey: "EVENT_COUNTRY_ROMANIA" },
  { label: "Hungary", value: "hu", translationKey: "EVENT_COUNTRY_HUNGARY" },
  {
    label: "Slovakia",
    value: "sk",
    translationKey: "EVENT_COUNTRY_SLOVAK_REPUBLIC",
  },
  {
    label: "Czechia",
    value: "cz",
    translationKey: "EVENT_COUNTRY_CZECH_REPUBLIC",
  },
];
